import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// @ts-ignore Ignore unused commented AuthGuard import
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { InformationComponent } from './information.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [InformationComponent],
  imports: [CommonModule, SharedModule, RouterModule, MatIconModule],
})
export class InformationModule {}
